import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, PlusCircle, Wrench } from "lucide-react";

export default function JurnalUmum() {
  return (
    <div className="space-y-4" data-testid="jurnal-umum-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold text-navy">Jurnal Umum</h1>
          <p className="text-sm text-muted-foreground">Pencatatan jurnal akuntansi</p>
        </div>
        <Button disabled data-testid="add-jurnal-btn" className="bg-primary/60 cursor-not-allowed" title="Segera Tersedia">
          <PlusCircle size={16} className="mr-1.5" /> Jurnal Baru
          <span className="ml-2 text-[10px] bg-white/25 rounded px-1.5 py-0.5">Segera Tersedia</span>
        </Button>
      </div>
      <Card className="p-12 flex flex-col items-center justify-center text-center gap-3" data-testid="jurnal-umum-empty">
        <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
          <BookOpen size={26} className="text-slate-400" />
        </div>
        <h2 className="font-heading text-base font-semibold text-navy">Belum ada jurnal</h2>
        <p className="text-sm text-muted-foreground max-w-md">
          Modul Jurnal Umum untuk pencatatan transaksi akuntansi sedang disiapkan. Belum ada entri jurnal yang tercatat.
        </p>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-1">
          <Wrench size={13} /> Segera Tersedia
        </div>
      </Card>
    </div>
  );
}
